var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandAuthyStyleWhite = function SvgBrandAuthyStyleWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandAuthyStyleWhite__clip0_3953_128870)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 24c6.628 0 12-5.372 12-12S18.628 0 12 0 0 5.372 0 12s5.372 12 12 12m2.686-16.868a1.063 1.063 0 1 1 1.505-1.505l2.878 2.876a5.38 5.38 0 0 1 .052 7.545q-.013.015-.027.027l-.009.01-.016.017-.05.045-.008.007a5.38 5.38 0 0 1-7.49-.105l-2.876-2.877a1.064 1.064 0 1 1 1.507-1.506l2.877 2.877a3.246 3.246 0 0 0 4.558.026 3.247 3.247 0 0 0-.025-4.56zm-.838 5.203-2.877-2.877a3.246 3.246 0 0 0-4.559-.026 3.246 3.246 0 0 0 .026 4.56l2.878 2.877a1.064 1.064 0 1 1-1.507 1.506L4.93 15.498a5.38 5.38 0 0 1-.053-7.546l.016-.016.011-.01.015-.016.011-.011.057-.052a5.38 5.38 0 0 1 7.489.105l2.877 2.877a1.064 1.064 0 1 1-1.506 1.506",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandAuthyStyleWhite__clip0_3953_128870"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandAuthyStyleWhite);
export { ForwardRef as ReactComponent };